interface Props {
  src?: string;
  className?: string;
}

export function Image({ src, className }: Props) {
  return (
    <img 
      className={className} 
      src={`${process.env.APP_IMAGES_DOMAIN}/${src}`}/>
  );
}
